import { getUserConfiguration } from 'owa-session-store';
import type RecursiveReadOnly from 'owa-service/lib/RecursiveReadOnly';
import type SessionSettingsType from 'owa-service/lib/contract/SessionSettingsType';

/**
 * Returns the session settings for the current user.
 *
 * This function assumes user configuration settings to have been loaded already.
 * This is the case for normal application code, which runs after bootstrap.
 */
export function getUserSessionSettings(): RecursiveReadOnly<SessionSettingsType> {
    return getUserConfiguration()?.SessionSettings || {};
}
